import { Theme as AugmentedTheme } from '@mui/material';


import { makeStyles } from 'tss-react/mui';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  container: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  subheader: {
    marginBottom: theme.spacing(6),
  },
  downloadPdf: {
    display: 'flex',
    paddingLeft: theme.spacing(3),
  },
  downloadPdfText: {
    fontWeight: 800,
    paddingLeft: theme.spacing(1),
  },
  downloadContainer: {
    paddingBottom: theme.spacing(2),
    maxWidth: 960,
  },
  statusContainer: {
    display: 'flex',
  },
  statusPill: {
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      paddingRight: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
  },
  registrationType: {
    [theme.breakpoints.down('md')]: { alignSelf: 'flex-end' },
    fontWeight: 700,
    color: theme.color.state.stateInfo,
  },
  divider: {
    paddingTop: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(-2),
    },
  },
  schoolContainer: {
    alignItems: 'center',
  },
  siblingContainer: {
    alignItems: 'center',
    marginTop: theme.spacing(8),
  },
  dividerContainer: {
    paddingTop: theme.spacing(4),
  },
  documentBadgeContainer: {
    marginTop: theme.spacing(4),
  },
  marginTop1: {
    marginTop: theme.spacing(1),
  },
  tableTitle: {
    marginBottom: theme.spacing(4),
  },
  additionalText: {
    marginTop: theme.spacing(1),
  },
}));
